// import React, { useState } from "react";
// import "../assets/KycLoanDetail.css";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const API_URL = "https://payyug.in/api";

// export default function KycLoanDetail() {
//   const [filterType, setFilterType] = useState("");
//   const [filterValue, setFilterValue] = useState("");
//   const [loanDetail, setLoanDetail] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);

//   // 🔹 Modal state
//   const [previewImage, setPreviewImage] = useState(null);

//   // ✅ Fetch Loan Details
//   const handleSearch = async () => {
//     if (!filterType || !filterValue.trim()) {
//       toast.warning("Please select filter type and provide value.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_URL}/get-loan-by`, {
//         params: {
//           loanAccountNumber:
//             filterType === "loanAccountNumber" ? filterValue.trim() : null,
//           id: filterType === "userId" ? filterValue.trim() : null,
//         },
//       });

//       if (response.data?.success && response.data?.data) {
//         setLoanDetail(response.data.data);
//         toast.success("Loan details fetched successfully!");

//         // ✅ Fetch KYC docs for this loan
//         fetchUploadedKyc(response.data.data.loanAccountNumber);
//       } else {
//         setLoanDetail(null);
//         setUploadedKyc([]);
//         toast.error("No loan details found!");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to fetch loan details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Fetch Uploaded KYC Docs
//   const fetchUploadedKyc = async (loanAccountNumber) => {
//     try {
//       const response = await fetch(
//         `https://payyug.in/api/get-new-loan-kyc?accountNumber=${loanAccountNumber}`
//       );
//       const result = await response.json();

//       if (response.ok) {
//         setUploadedKyc(result.documents || []);
//       } else {
//         setUploadedKyc([]);
//         toast.error("Failed to fetch uploaded documents.");
//       }
//     } catch (err) {
//       toast.error("Error fetching uploaded documents.");
//       console.error(err);
//       setUploadedKyc([]);
//     }
//   };

//   // // ✅ Handle Approve / Reject with API integration
//   // const handleAction = async (id, action) => {
//   //   try {
//   //     const endpoint =
//   //       action === "Approved"
//   //         ? `${API_URL}/new-loan-kyc/${id}/approve`
//   //         : `${API_URL}/new-loan-kyc/${id}/reject`;

//   //     const response = await axios.put(endpoint);

//   //     if (response.data?.success) {
//   //       toast.success(`Document ${action} successfully!`);

//   //       // ✅ Update UI after backend success
//   //       setUploadedKyc((prev) =>
//   //         prev.map((doc) =>
//   //           doc.id === id ? { ...doc, status: action } : doc
//   //         )
//   //       );
//   //     } else {
//   //       toast.success(
//   //         response.data?.message || `Failed to ${action.toLowerCase()} document.`
//   //       );
//   //     }
//   //   } catch (err) {
//   //     console.error(err);
//   //     toast.error(`Error while trying to ${action.toLowerCase()} document.`);
//   //   }
//   // };

// const handleAction = async (id, action) => {
//   try {
//     let endpoint;

//     if (action === "Approved") {
//       endpoint = `${API_URL}/new-loan-kyc/${id}/approve`;
//     } else if (action === "Rejected") {
//       endpoint = `${API_URL}/new-loan-kyc/${id}/reject`;
//     } else if (action === "Deleted") {
//       endpoint = `${API_URL}/delete-new-loan-kyc/${id}`;
//     }

//     // use DELETE for delete API
//     const response =
//       action === "Deleted" ? await axios.delete(endpoint) : await axios.put(endpoint);

//     if (response.data?.success) {
//       toast.success(`Document ${action} successfully!`);

//       if (action === "Deleted") {
//         setUploadedKyc((prev) => prev.filter((doc) => doc.id !== id));
//       } else {
//         setUploadedKyc((prev) =>
//           prev.map((doc) =>
//             doc.id === id ? { ...doc, status: action } : doc
//           )
//         );
//       }
//     } else {
//       toast.error(
//         response.data?.message || `Failed to ${action.toLowerCase()} document.`
//       );
//     }
//   } catch (err) {
//     console.error(err);
//     toast.error(`Error while trying to ${action.toLowerCase()} document.`);
//   }
// };

//   return (
//     <div className="LoanKyc-container">
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored" // 🔹 ensures green for success, red for error, yellow for warning
//       />

//       <h1 className="LoanKyc-title">Loan Kyc</h1>

//       {/* 1. Filter Loan */}
//       <section className="LoanKyc-section">
//         <h2 className="LoanKyc-section-title">1. Filter Loan</h2>
//         <div className="LoanKyc-filter-row">
//           <select
//             value={filterType}
//             onChange={(e) => {
//               setFilterType(e.target.value);
//               setFilterValue("");
//             }}
//           >
//             <option value="">Select Filter Type</option>
//             <option value="userId">User ID</option>
//             <option value="loanAccountNumber">Loan Account Number</option>
//           </select>

//           <input className="loankyc-input"
//             type="text"
//             placeholder={`Enter ${filterType}`}
//             value={filterValue}
//             onChange={(e) => setFilterValue(e.target.value)}
//           />

//           <button type="button" onClick={handleSearch} disabled={loading}>
//             {loading ? "Searching..." : "Search"}
//           </button>
//         </div>
//       </section>

//       {/* 2. Loan Details */}
//       {loanDetail && (
//         <section className="LoanKyc-section">
//           <h2 className="LoanKyc-section-title">2. Loan Details</h2>
//           <div className="LoanKyc-table-wrapper">
//             <table className="LoanKyc-details-table">
//               <tbody>
//                 <tr>
//                   <th>User Name</th>
//                   <td>{loanDetail.userName}</td>
//                 </tr>
//                 <tr>
//                   <th>User ID</th>
//                   <td>{loanDetail.userId}</td>
//                 </tr>
//                 <tr>
//                   <th>Loan Account</th>
//                   <td>{loanDetail.loanAccountNumber}</td>
//                 </tr>
//                 <tr>
//                   <th>Loan Type</th>
//                   <td>{loanDetail.loanType}</td>
//                 </tr>
//                 <tr>
//                   <th>Loan Amount</th>
//                   <td>{loanDetail.loanAmount}</td>
//                 </tr>
//                 <tr>
//                   <th>Loan Tenure</th>
//                   <td>
//                     {loanDetail.loanTenure} {loanDetail.tenuretype}
//                   </td>
//                 </tr>
//                 <tr>
//                   <th>ROI</th>
//                   <td>{loanDetail.loanRoi} %</td>
//                 </tr>
//                 <tr>
//                   <th>EMI Amount</th>
//                   <td>{loanDetail.loanEmiAmount}</td>
//                 </tr>
//                 <tr>
//                   <th>Loan Status</th>
//                   <td>{loanDetail.status}</td>
//                 </tr>
//                 <tr>
//                   <th>KYC Status</th>
//                   <td>{loanDetail.kycStatus}</td>
//                 </tr>
//                 <tr>
//                   <th>Disbursal Date</th>
//                   <td>
//                     {new Date(loanDetail.disbursalDate).toLocaleDateString()}
//                   </td>
//                 </tr>
//                 <tr>
//                   <th>Collection Landmark</th>
//                   <td>{loanDetail.collectionLandmark}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </section>
//       )}

//       {/* 3. Loan KYC Document List */}
//       {uploadedKyc.length > 0 && (
//         <section className="LoanKyc-section">
//           <h2 className="LoanKyc-section-title">
//             3. Loan KYC Document Details
//           </h2>
//           <div className="LoanKyc-table-wrapper">
//             <table className="LoanKyc-table">
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Document Name</th>
//                   <th>Status</th>
//                   <th>Preview</th>
//                   <th>Action</th>
//                   <th>Delete</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {uploadedKyc.map((doc, idx) => (
//                   <tr key={doc.id}>
//                     <td>{idx + 1}</td>
//                     <td>{doc.docName}</td>
//                     <td>
//                        {doc.status}
//                       {/* <span
//                         className={`status-badge ${
//                           doc.status === "Approved"
//                             ? "approved"
//                             : doc.status === "Rejected"
//                             ? "rejected"
//                             : "pending"
//                         }`}
//                       >
//                         {doc.status}
//                       </span> */}
//                     </td>
//                     <td>
//                       <button
//                         className="preview-btn"
//                         onClick={() =>
//                           setPreviewImage(
//                             `https://payyug.in/uploads/${doc.docImage}`
//                           )
//                         }
//                       >
//                         Preview
//                       </button>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button
//                           className="approve-btn"
//                           onClick={() => handleAction(doc.id, "Approved")}
//                         >
//                           Approve
//                         </button>
//                         <button
//                           className="reject-btn"
//                           onClick={() => handleAction(doc.id, "Rejected")}
//                         >
//                           Reject
//                         </button>
//                       </div>
//                     </td>
// <td>
//   <button
//     className="delete-btn"
//     onClick={() => setConfirmDeleteId(doc.id)} // open confirm modal
//   >
//     Delete
//   </button>
// </td>

//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </section>
//       )}

//       {confirmDeleteId && (
//   <div className="modal-overlay" onClick={() => setConfirmDeleteId(null)}>
//     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//       <h3>Are you sure?</h3>
//       <p>Do you really want to delete this document?</p>
//       <div className="modal-actions">
//         <button
//           className="cancel-btn"
//           onClick={() => setConfirmDeleteId(null)}
//         >
//           Cancel
//         </button>
//         <button
//           className="delete-btn"
//           onClick={() => {
//             handleAction(confirmDeleteId, "Deleted");
//             setConfirmDeleteId(null);
//           }}
//         >
//           Yes, Delete
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       {/* 🔹 Preview Modal */}
//       {previewImage && (
//         <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <img src={previewImage} alt="KYC Preview" className="modal-image" />
//             <button
//               className="modal-close"
//               onClick={() => setPreviewImage(null)}
//             >
//               ×
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import React, { useState, useEffect, useMemo } from "react";
import "../assets/KycLoanDetail.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const API_URL = "https://payyug.in/api";

export default function KycLoanDetail() {
  // --- STATES ---
  const [masterLoanData, setMasterLoanData] = useState([]); // Poora data ek baar yahan aayega
  const [filterType, setFilterType] = useState("loanAccountNumber"); // Default type
  const [selectedOption, setSelectedOption] = useState(null);
  const [loanDetail, setLoanDetail] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const superAdminId = localStorage.getItem("adminuserId");
  // ✅ 1. API Call Only Once: Fetch all loans on component mount
  useEffect(() => {
    const fetchAllDataOnce = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${API_URL}/get-all-loan?superAdminId=${superAdminId}`,
        );
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setMasterLoanData(sortedData); // Saara data store kar liya
      } catch (error) {
        toast.error("Failed to load Master Data");
      } finally {
        setLoading(false);
      }
    };
    fetchAllDataOnce();
  }, []);

  // ✅ 2. Frontend Filtering: filterType ke basis par options generate karna
  // useMemo use kiya hai taaki dropdown options sirf tabhi badlein jab filterType ya data badle
  const dropdownOptions = useMemo(() => {
    return masterLoanData.map((loan) => {
      if (filterType === "loanAccountNumber") {
        return {
          value: loan.loanAccountNumber,
          label: `${loan.loanAccountNumber} (${loan.userName})`,
        };
      } else if (filterType === "userId") {
        return {
          value: loan.userId,
          label: `User ID: ${loan.userId} (${loan.userName})`,
        };
      } else if (filterType === "mobileNumber") {
        return {
          value: loan.mobileNumber,
          label: `${loan.mobileNumber} (${loan.userName})`,
        };
      }
      return { value: loan.loanAccountNumber, label: loan.loanAccountNumber };
    });
  }, [masterLoanData, filterType]);

  // ✅ 3. Search Details: Master data se hi find kar lena (No extra API call for details)
  const handleSearch = () => {
    if (!selectedOption) {
      toast.warning("Please select an option.");
      return;
    }

    // Master data mein se wo record dhoondo jo dropdown selection se match kare
    const detail = masterLoanData.find(
      (item) => String(item[filterType]) === String(selectedOption.value),
    );

    if (detail) {
      setLoanDetail(detail);
      toast.success("Details loaded!");
      fetchUploadedKyc(detail.loanAccountNumber); // KYC ke liye alag API call zaroori hai
    } else {
      toast.error("Details not found in master list");
    }
  };

  const fetchUploadedKyc = async (loanAccountNumber) => {
    try {
      const response = await fetch(
        `${API_URL}/get-new-loan-kyc?accountNumber=${loanAccountNumber}`,
      );
      const result = await response.json();
      if (response.ok) setUploadedKyc(result.documents || []);
    } catch (err) {
      setUploadedKyc([]);
    }
  };

  // --- Actions (Approve/Reject/Delete) remain same ---
  const handleAction = async (id, action) => {
    try {
      let endpoint;
      if (action === "Approved")
        endpoint = `${API_URL}/new-loan-kyc/${id}/approve`;
      else if (action === "Rejected")
        endpoint = `${API_URL}/new-loan-kyc/${id}/reject`;
      else if (action === "Deleted")
        endpoint = `${API_URL}/delete-new-loan-kyc/${id}`;

      const response =
        action === "Deleted"
          ? await axios.delete(endpoint)
          : await axios.put(endpoint);

      if (response.data?.success) {
        toast.success(`Document ${action} successfully!`);
        if (action === "Deleted") {
          setUploadedKyc((prev) => prev.filter((doc) => doc.id !== id));
        } else {
          setUploadedKyc((prev) =>
            prev.map((doc) =>
              doc.id === id ? { ...doc, status: action } : doc,
            ),
          );
        }
      }
    } catch (err) {
      toast.error("Action failed");
    }
  };

  return (
    <div className="LoanKyc-container">
      <ToastContainer position="top-right" theme="colored" />
      <h1 className="LoanKyc-title">Loan Kyc Management</h1>

      {/* Filter Section */}
      <section className="LoanKyc-section">
        <h2 className="LoanKyc-section-title">1. Loan Kyc Filter</h2>
        <div className="LoanKyc-filter-row-wrapper">
          <div className="LoanKyc-filter-row">
            {/* Dropdown to choose Filter Property */}
            <select
              className="loankyc-select-type"
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setSelectedOption(null); // Reset selection
              }}
            >
              <option value="loanAccountNumber">Loan Account Number</option>
              {/* <option value="userId">User ID</option>
            <option value="mobileNumber">Mobile Number</option> */}
            </select>

            {/* Searchable Dropdown filtered from Master Data */}
            <Select
              className="loan-filter-Select"
              options={dropdownOptions}
              value={selectedOption}
              onChange={setSelectedOption}
              placeholder={`Search by ${filterType}...`}
              isSearchable
              isLoading={loading}
            />
          </div>
        </div>
        <button type="button" onClick={handleSearch} className="loan-kyc-search-btn">
          View Details
        </button>
      </section>

      {/* Details Table (All 12 Fields) */}
      {loanDetail && (
        <section className="LoanKyc-section">
          <h2 className="LoanKyc-section-title">2. Loan Details</h2>
          <div className="LoanKyc-table-wrapper">
            <table className="LoanKyc-details-table">
              <tbody>
                <tr>
                  <th>User Name</th>
                  <td>{loanDetail.userName}</td>
                </tr>
                <tr>
                  <th>User ID</th>
                  <td>{loanDetail.userId}</td>
                </tr>
                <tr>
                  <th>Loan Account</th>
                  <td>{loanDetail.loanAccountNumber}</td>
                </tr>
                <tr>
                  <th>Loan Type</th>
                  <td>{loanDetail.loanType}</td>
                </tr>
                <tr>
                  <th>Loan Amount</th>
                  <td>{loanDetail.loanAmount}</td>
                </tr>
                <tr>
                  <th>Loan Tenure</th>
                  <td>
                    {loanDetail.loanTenure} {loanDetail.tenuretype}
                  </td>
                </tr>
                <tr>
                  <th>ROI</th>
                  <td>{loanDetail.loanRoi} %</td>
                </tr>
                <tr>
                  <th>EMI Amount</th>
                  <td>{loanDetail.loanEmiAmount}</td>
                </tr>
                <tr>
                  <th>Loan Status</th>
                  <td>{loanDetail.status}</td>
                </tr>
                <tr>
                  <th>KYC Status</th>
                  <td>{loanDetail.kycStatus}</td>
                </tr>
                <tr>
                  <th>Disbursal Date</th>
                  <td>
                    {loanDetail.disbursalDate
                      ? new Date(loanDetail.disbursalDate).toLocaleDateString(
                          "en-GB",
                        )
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <th>Collection Landmark</th>
                  <td>{loanDetail.collectionLandmark}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* KYC Documents Table */}
      {uploadedKyc.length >= 0 && (
        <section className="LoanKyc-section">
          <h2 className="LoanKyc-section-title">
            3. Loan KYC Document Details
          </h2>
          <div className="LoanKyc-table-wrapper">
            <table className="LoanKyc-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Document Name</th>
                  <th>Status</th>
                  <th>Preview</th>
                  <th>Action</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName}</td>
                    <td>
                      <span
                        className={`status-badge ${doc.status?.toLowerCase()}`}
                      >
                        {doc.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="preview-btn"
                        onClick={() =>
                          setPreviewImage(
                            `https://payyug.in/uploads/${doc.docImage}`,
                          )
                        }
                      >
                        Preview
                      </button>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="approve-btn"
                          onClick={() => handleAction(doc.id, "Approved")}
                        >
                          Approve
                        </button>
                        <button
                          className="reject-btn"
                          onClick={() => handleAction(doc.id, "Rejected")}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => setConfirmDeleteId(doc.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Modals remain same as your original code */}
      {confirmDeleteId && (
        <div className="modal-overlay" onClick={() => setConfirmDeleteId(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Are you sure?</h3>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setConfirmDeleteId(null)}
              >
                Cancel
              </button>
              <button
                className="delete-btn"
                onClick={() => {
                  handleAction(confirmDeleteId, "Deleted");
                  setConfirmDeleteId(null);
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {previewImage && (
        <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="KYC Preview" className="modal-image" />
            <button
              className="modal-close"
              onClick={() => setPreviewImage(null)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
